import { Navigate } from "react-router-dom";
import { useAuth } from "./auth-context";
import { ReactNode } from "react";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated, isAuthReady } = useAuth();
  if (!isAuthReady) {
    return (
      <div className="loader-overlay">
        <div className="loader" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-up" replace />;
  }

  return children;
};

export default ProtectedRoute;
